/*
 * Bravo · Esconde la caja de Kaching Bundles cuando no ofrece ningun pack.
 *
 * Cuando un producto no tiene oferta, o la tiene pero Kaching no puede
 * mostrarla (por ejemplo, porque falta stock de algo del pack), la app deja
 * igualmente su recuadro con una sola linea: el producto suelto a su precio
 * normal. No aporta nada y ensucia la ficha, asi que se oculta.
 *
 * Como se distingue una barra de pack de la del producto suelto: la de pack
 * siempre lleva el precio anterior tachado. Es estructural, no depende de los
 * textos ni del idioma.
 *
 * Se vuelve a mirar cada vez que Kaching repinta (al cambiar de variante puede
 * aparecer o desaparecer un pack).
 */
(function () {
  'use strict';

  var ESPERA_MAXIMA = 8000;
  var TACHADO = 's, del, [class*="compare"], [class*="old-price"], [class*="strike"]';

  /*
   * Se mira el estilo propio de la barra, no su tamaño en pantalla: si se
   * midiera el tamaño, al ocultar la caja las barras pasarían a medir cero y
   * ya nunca volvería a mostrarse.
   */
  function apagada(el) {
    return getComputedStyle(el).display === 'none';
  }

  function esPack(barra) {
    return !!barra.querySelector(TACHADO);
  }

  function revisar(bloque, ultimaOportunidad) {
    var todas = Array.prototype.slice.call(bloque.querySelectorAll('[data-deal-bar-id]'));
    var barras = todas.filter(function (b) {
      return !apagada(b);
    });

    /* Kaching aún no ha pintado nada: se espera, salvo que se acabe el tiempo. */
    if (!todas.length && !ultimaOportunidad) return;

    /* Hay algo que elegir si se ven dos o más opciones, o si la única que hay
       ya es un pack con descuento. */
    var ofreceAlgo = barras.length > 1 || (barras.length === 1 && esPack(barras[0]));

    bloque.style.display = ofreceAlgo ? '' : 'none';
    bloque.dataset.bravoKachingVacio = ofreceAlgo ? 'no' : 'si';
  }

  function vigilar(bloque) {
    revisar(bloque);

    var pendiente = null;
    var obs = new MutationObserver(function () {
      /* Kaching repinta en varios pasos: se espera a que pare. */
      clearTimeout(pendiente);
      pendiente = setTimeout(function () {
        revisar(bloque);
      }, 120);
    });
    obs.observe(bloque, {childList: true, subtree: true});

    /* Si pasado el tiempo Kaching no ha pintado ninguna barra, la caja está
       vacía de verdad y se oculta. */
    setTimeout(function () {
      revisar(bloque, true);
    }, ESPERA_MAXIMA);
  }

  function arrancar() {
    var bloque = document.querySelector('kaching-bundles-block');
    if (bloque) return vigilar(bloque);

    if (!document.querySelector('script[src*="kaching-bundles"]')) return;

    var desde = Date.now();
    var obs = new MutationObserver(function () {
      var b = document.querySelector('kaching-bundles-block');
      if (b) {
        obs.disconnect();
        vigilar(b);
      } else if (Date.now() - desde > ESPERA_MAXIMA) {
        obs.disconnect();
      }
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
